import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AddToShelfInput } from '@booknest/shared';

import { libraryApi } from '../api/library.api.js';

export function useAddToShelf() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: AddToShelfInput) => libraryApi.addToShelf(input),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['shelf'] });
    },
  });
}
